import {
    CREATE_HATCH_ANSWER,
    CREATE_HATCH_ANSWER_SUCCESS,
    UPDATE_HATCH_ANSWER,
    UPDATE_HATCH_ANSWER_SUCCESS,
    DELETE_HATCH_ANSWER,
    DELETE_HATCH_ANSWER_SUCCESS
} from './constants';

/**
 *
 * @param questionID
 * @param answer
 * @param localizationId
 * @param questionType
 * @param resolve
 * @returns {{questionID: *, answer: *, resolve: *, localizationId: *, type: string, questionType: *}}
 */
const createAnswer = ( questionID, answer, localizationId, questionType, resolve ) => ( {
    type: CREATE_HATCH_ANSWER,
    questionID,
    answer,
    localizationId,
    questionType,
    resolve
} );
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const createAnswerSuccess = ( questionID, question ) => ( {
    type: CREATE_HATCH_ANSWER_SUCCESS,
    questionID,
    question
} );

/**
 *
 * @param questionID
 * @param answerId
 * @param answer
 * @param localizationID
 * @param questionType
 * @param resolve
 * @returns {{answerId: *, questionID: *, answer: *, resolve: *, localizationID: *, type: string, questionType: *}}
 */
const updateAnswer = ( questionID, answerId, answer, localizationID, questionType, resolve ) => ( {
    type: UPDATE_HATCH_ANSWER,
    questionID,
    answerId,
    answer,
    localizationID,
    questionType,
    resolve
} );
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const updateAnswerSuccess = ( questionID, question ) => ( {
    type: UPDATE_HATCH_ANSWER_SUCCESS,
    questionID,
    question
} );
/**
 *
 * @param questionID
 * @param answerId
 * @param questionType
 * @returns {{answerId: *, questionID: *, type: string, questionType: *}}
 */
const deleteAnswer = ( questionID, answerId, questionType ) => ( {
    type: DELETE_HATCH_ANSWER,
    questionID,
    answerId,
    questionType
} );
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const deleteAnswerSuccess = ( questionID, question ) => ( {
    type: DELETE_HATCH_ANSWER_SUCCESS,
    questionID,
    question
} );

export {
    createAnswer,
    createAnswerSuccess,
    updateAnswer,
    updateAnswerSuccess,
    deleteAnswer,
    deleteAnswerSuccess
};